import { gameState } from '@js/state';

const SCREEN_W = 1280;
const SCREEN_H = 720;

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({ key: 'EndScene' });
  }

  preload() {
    this.load.image('endScreenOverlay', 'assets/EndScreenAssets/end screen.png');
    this.load.image('youWon', 'assets/EndScreenAssets/You Won.png');
    this.load.image('endNextButton', 'assets/EndScreenAssets/Button CTA.png');
    this.load.image('endNextHover', 'assets/EndScreenAssets/next hover.png');
    this.load.image('okayButton', 'assets/EndScreenAssets/okaybutton.png');
    this.load.image('okayHover', 'assets/EndScreenAssets/okayHover.png');
    this.load.image('okayDisabled', 'assets/EndScreenAssets/okayDisabled.png');
    this.load.image('rewardEarned', 'assets/EndScreenAssets/Rewards earned!.png');
    this.load.image('rewardName', 'assets/EndScreenAssets/coins.png');

    this.load.multiatlas(
      'spotlight',
      'assets/EndScreenAssets/spotlight/spotlightAnimNew.json',
      'assets/EndScreenAssets/spotlight',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/EndScreenAssets/confetti/confettiAnimNew.json',
      'assets/EndScreenAssets/confetti',
    );
    this.load.multiatlas(
      'rewardAnim',
      'assets/EndScreenAssets/coinRewardAnim/rewardAnim.json',
      'assets/EndScreenAssets/coinRewardAnim',
    );
  }

  create() {
    this.cameras.main.fadeIn(800, 0, 0, 0);

    if (gameState.bgMusic) {
      this.tweens.add({
        targets: gameState.bgMusic,
        volume: 0,
        duration: 1000,
        onComplete: () => gameState.bgMusic && gameState.bgMusic.destroy(),
      });
    }

    this.endOverlay = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'endScreenOverlay');

    this.spotlight = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'spotlight');
    this.anims.create({
      key: 'spotlightOpen',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'endConfetti');
    this.anims.create({
      key: 'endConfetti',
      frames: this.anims.generateFrameNames('endConfetti', {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(2000, () => this.spotlight.play('spotlightOpen'), [], this);

    this.youWon = this.add.sprite(SCREEN_W / 2, SCREEN_H / 2, 'youWon').setAlpha(0);
    this.tweens.add({
      targets: this.youWon,
      ease: 'Expo.easeInOut',
      duration: 1000,
      delay: 300,
      alpha: 1,
    });
    this.tweens.add({
      targets: this.youWon,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: SCREEN_H / 2 - 50,
    });

    this.endConfetti.play('endConfetti');

    this.nextButton = this.add
      .sprite(SCREEN_W / 2, 740, 'endNextButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.tweens.add({
      targets: this.nextButton,
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: 1,
      y: 650,
    });

    this.anims.create({
      key: 'rewardShow',
      frames: this.anims.generateFrameNames('rewardAnim', {
        start: 0,
        end: 74,
        zeroPad: 0,
        prefix: 'coin',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
    this.anims.create({
      key: 'rewardLoop',
      frames: this.anims.generateFrameNames('rewardAnim', {
        start: 75,
        end: 155,
        zeroPad: 0,
        prefix: 'coin',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.reward = this.add
      .sprite(SCREEN_W / 2, SCREEN_H / 2, 'rewardAnim')
      .setScale(0.45)
      .setVisible(false);

    this.okButton = this.add
      .sprite(SCREEN_W / 2, 740, 'okayButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.nextButton.on('pointerover', () => this.nextButton.setTexture('endNextHover'));
    this.nextButton.on('pointerout', () => this.nextButton.setTexture('endNextButton'));

    this.nextButton.on('pointerup', () => {
      this.tweens.add({
        targets: [this.youWon, this.nextButton],
        alpha: 0,
        duration: 300,
      });

      this.time.delayedCall(
        1000,
        () => {
          this.reward.setVisible(true).play('rewardShow');
          this.add.sprite(581, 126, 'rewardEarned').setOrigin(0);
          this.add.sprite(SCREEN_W / 2, 580, 'rewardName').setOrigin(0.5, 0);

          this.tweens.add({
            targets: this.okButton,
            ease: 'Linear',
            duration: 300,
            delay: 3000,
            alpha: 1,
            y: 650,
          });
        },
        [],
        this,
      );

      this.reward.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'rewardShow',
        () => this.reward.play('rewardLoop'),
        this,
      );
    });

    this.okButton.on('pointerover', () => this.okButton.setTexture('okayHover'));
    this.okButton.on('pointerout', () => this.okButton.setTexture('okayButton'));
    this.okButton.on('pointerup', () => {
      this.okButton.setTexture('okayDisabled');
      this.okButton.removeInteractive();
    });
  }

  update() {}
}
